import { useState, useEffect } from "react";
import "./styles.css";

const suggestions = [
  { metier: "plombier", ville: "Grenoble" },
  { metier: "développeur web", ville: "Amiens" },
  { metier: "menuisier", ville: "Marseille" },
  { metier: "paysagiste", ville: "Paris" },
  { metier: "électricien", ville: "Toulouse" },
];


export default function SearchHeroTypewriter({ onMetierChange, onVilleChange }) {
  const [index, setIndex] = useState(0);
  const [subIndexMetier, setSubIndexMetier] = useState(0);
  const [subIndexVille, setSubIndexVille] = useState(0);
  const [phase, setPhase] = useState("typingMetier");
  const [allMetiers, setAllMetiers] = useState([]);
  const [filteredMetiers, setFilteredMetiers] = useState([]);
  const [showMetiers, setShowMetiers] = useState(false);
  const apiUrl = process.env.REACT_APP_API_URL;

  // typingMetier | typingVille | deletingVille | deletingMetier

  const [fullText, setFullText] = useState(""); // Contient métier + ville

  const current = suggestions[index];




  useEffect(() => {
    let handler;
    const speed = 150;

    switch (phase) {
      case "typingMetier":
        if (subIndexMetier <= current.metier.length) {
          handler = setTimeout(() => {
            const metierPart = current.metier.substring(0, subIndexMetier);
            setFullText(metierPart);
            onMetierChange?.(metierPart);
            setSubIndexMetier(subIndexMetier + 1);
          }, speed);
        } else {
          setPhase("typingVille");
          setSubIndexVille(0);
        }
        break;

      case "typingVille":
        if (subIndexVille <= current.ville.length) {
          handler = setTimeout(() => {
            const villePart = current.ville.substring(0, subIndexVille);
            const combined = `${current.metier}, ${villePart}`;
            setFullText(combined);
            onVilleChange?.(villePart);
            setSubIndexVille(subIndexVille + 1);
          }, speed);
        } else {
          handler = setTimeout(() => setPhase("deletingVille"), 1500);
        }
        break;

      case "deletingVille":
        if (subIndexVille >= 0) {
          handler = setTimeout(() => {
            const villePart = current.ville.substring(0, subIndexVille);
            const combined = villePart
              ? `${current.metier}, ${villePart}`
              : current.metier;
            setFullText(combined);
            onVilleChange?.(villePart);
            setSubIndexVille(subIndexVille - 1);
          }, speed / 2);
        } else {
          setPhase("deletingMetier");
        }
        break;

      case "deletingMetier":
        if (subIndexMetier >= 0) {
          handler = setTimeout(() => {
            const metierPart = current.metier.substring(0, subIndexMetier);
            setFullText(metierPart);
            onMetierChange?.(metierPart);
            setSubIndexMetier(subIndexMetier - 1);
          }, speed / 2);
        } else {
          setIndex((prev) => (prev + 1) % suggestions.length);
          setPhase("typingMetier");
        }
        break;
    }

    return () => clearTimeout(handler);
  }, [subIndexMetier, subIndexVille, phase, current, onMetierChange, onVilleChange]);


  return (
    <div className="search-wrapper">
      <input
        type="text"
        value={fullText}
        placeholder="Ex: Plombier, Paris"
        className="search-input"
        readOnly
      />
      <span className="cursor">|</span>
      <span className="search-icon">🔍</span>
      


    </div>
  );
}
